import React from 'react';

import {
  ScrollView,
  View,
} from 'react-native';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import { a } from './_csAbt';

/*
const _SrlCell = React.memo((pd: ht.srlCz) => {

  const _abtType = pd.abtType ?? 'nmlz';
  const _abtz = ica.srlAbtz[_abtType] ? ica.srlAbtz[_abtType]() : {};

  return (
    cr.c(ScrollView, {
      key: 'Srl.root',
      ... pd.srlPtyz,
      style: {
        ..._abtz.srlStlz?.otrz,
        ...pd.srlStlz?.otrz,
      },
      contentContainerStyle: {
        ..._abtz.srlStlz?.inrz,
        ...pd.srlStlz?.inrz,
      },
    }, 
      pd.oClds
    )
  );
});
*/

export type tScrollViewRef = ScrollView & {
    flashScrollIndicators: () => void;
};

export const V = React.memo((pd: ht.srlCz) => {

  const _rrc = React.useRef<tScrollViewRef | null>(null);

  React.useEffect(() => {
      setTimeout(function () {
          _rrc.current?.flashScrollIndicators();
      }, 500);
  }, []);

  const _abtType = pd.abtType ?? 'nmlz';
  const _abtz = ica.srlAbtz[_abtType] ? ica.srlAbtz[_abtType]() : {};

  return (
    cr.c(ScrollView, {
      key: 'Srl.V.root',
      horizontal: false,
      showsHorizontalScrollIndicator: true,
      showsVerticalScrollIndicator: true,
      persistentScrollbar: true,
      ref: _rrc,
      ...pd.srlPtyz,
      style: {
        ..._abtz.srlStlz?.otrz,
        ...pd.srlStlz?.otrz,
      },
      contentContainerStyle: {
        ..._abtz.srlStlz?.inrz,
        ...pd.srlStlz?.inrz,
      },
    }, 
      pd.oClds
    )
  );
});

/*
export const H = React.memo((pd: ht.srlCz) => {
  return (
    cr.c(_SrlCell, {
      key: 'Srl.H.root',
      ...pd,
      srlPtyz: {
        horizontal: true,
        showsHorizontalScrollIndicator: true,
        showsVerticalScrollIndicator: false,
        persistentScrollbar: true,
        ...pd.srlPtyz,
      },
    })
  )
});
*/

export const M = React.memo((pd: { // Marquee
  boxStlz: ht.boxStlz,
  cz?: {
    spd: ht.n,
    wait: ht.n,
  },
  oClds: ht.ls
  srlStlz: ht.srlStlz,
}) => {

  const _rThis = React.useRef<null | ScrollView>(null);

  return (
    cr.c(View, { // ScrollView の height 指定に必要
      key: 'Mrq.root',
      style: {
        ... a('dw/f p/1'),
        ... pd.boxStlz,
      }
    },
      cr.c(ScrollView, {
        key: -10,
        ref: _rThis,
        style: {
          ... a('dh/f dw/f'),
          ... pd.srlStlz?.otrz,
        },
        contentContainerStyle: {
          ... a('fd/rsc'),
          ... pd.srlStlz?.inrz,
        },
        onLayout: async ( _dz: ht.dz ) => {
          const _w = _dz.nativeEvent.layout.width;
//          const _nWait = pd.crlz.nWait ?? 5000;
          const _wait = pd.cz?.wait ?? 5000;
          let _x = 0;
          for (;;) {
            if ( _x == 0 ) await hf.waitAsync(_wait); // 少し待機
            _x += pd.cz?.spd ?? 1;
            _rThis?.current?.scrollTo({ x: _x, animated: true})
            if ( _x >= _w ) {
              await hf.waitAsync(_wait); // 少し待機
              _x = 0;
              _rThis?.current?.scrollTo({ x: _x, animated: false})
            }
            await hf.waitAsync(100); // 短すぎるとアニメーションが追いつかないため、100 固定
          }
        },
        horizontal: true,
        showsHorizontalScrollIndicator: false,
      }, 
/*
        hf.getRng(10).map( () => {
          return pd.oClds;
        })
*/
        pd.oClds,
      )
    )
  );

});
